<template>
    <div :class="['game-responsive',  aspectRatioClass]">
        <iframe id="softgamings-container" ref="container" sandbox="allow-same-origin allow-scripts allow-popups allow-forms">
        </iframe>
    </div>
</template>

<script>
    import Vue from "vue";
    import isMobile from "ismobilejs";

    export default {
        name: "game-softgamings",
        props: {
            gameId: {
                type: Object,
                required: true
            }
        },
        computed: {
            lang() {
                return Vue.state.lang.currentLang;
            },
            session() {
                return Vue.state.softgamings.session.get();
            },
            isLoggedIn() {
                return Vue.state.player.isLoggedIn();
            },
            container() {
                return this.$refs.container;
            },
            aspectRatioClass() {
                switch (this.game.aspectRatio) {
                    case "4:3":
                        return "responsive_3x4";
                    case "16:9":
                        return "responsive_9x16";
                    case "16:10":
                        return "responsive_10x16";
                    default:
                        return "responsive_auto";
                }
            }
        },
        mounted() {
            this.resetFrameAsync();
        },
        destroyed() {
            this.container && (this.container.innerHTML = "");
        },
        methods: {
            async resetFrameAsync() {
                if (!this.container) return;
                await Vue.state.player.ensure();
                await Vue.state.softgamings.session.open({ lang: this.lang, game: this.gameId, isMobile: isMobile.any });
                const { gameHtml, gameScript } = JSON.parse(this.session.data);
                let content = `<html>
    <body>
        ${gameHtml}
        <script type="text/javascript">${gameScript}</` + `script>
    </body>
</html>
`;
                this.container.contentDocument.write(content);
            }
        }
    };
</script>

<style lang="scss">
</style>


// WEBPACK FOOTER //
// front/src/skins/bulmasite/components/pages/sitepages/game/game-softgamings.vue